import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Gift = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
  >
    <Path
      color={color}
      d="M20 6.45117H17.82C17.93 6.14117 18 5.80117 18 5.45117C18 3.79117 16.66 2.45117 15 2.45117C13.95 2.45117 13.04 2.99117 12.5 3.80117L12 4.47117L11.5 3.79117C10.96 2.99117 10.05 2.45117 9 2.45117C7.34 2.45117 6 3.79117 6 5.45117C6 5.80117 6.07 6.14117 6.18 6.45117H4C2.89 6.45117 2.01 7.34117 2.01 8.45117L2 19.4512C2 20.5612 2.89 21.4512 4 21.4512H20C21.11 21.4512 22 20.5612 22 19.4512V8.45117C22 7.34117 21.11 6.45117 20 6.45117ZM15 4.45117C15.55 4.45117 16 4.90117 16 5.45117C16 6.00117 15.55 6.45117 15 6.45117C14.45 6.45117 14 6.00117 14 5.45117C14 4.90117 14.45 4.45117 15 4.45117ZM9 4.45117C9.55 4.45117 10 4.90117 10 5.45117C10 6.00117 9.55 6.45117 9 6.45117C8.45 6.45117 8 6.00117 8 5.45117C8 4.90117 8.45 4.45117 9 4.45117ZM20 19.4512H4V17.4512H20V19.4512ZM20 14.4512H4V8.45117H9.08L7 11.2812L8.62 12.4512L11 9.21117L12 7.85117L13 9.21117L15.38 12.4512L17 11.2812L14.92 8.45117H20V14.4512Z"
    />
  </svg>
);
